export enum ProductCode {
  Free = 'free',
  Basic = 'basic',
  Pro = 'pro',
  Ultimate = 'ultimate',
  Trial = 'trial',
}

export const paidProductCodes = [ProductCode.Basic, ProductCode.Pro, ProductCode.Ultimate]
